// extracted by mini-css-extract-plugin
module.exports = {"ccWidget":"pfQYNvPL","termsPartners":"_1tA-ajsw"};